import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { ModalsService } from '@ib-core/services/modals.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { CountriesHttpService } from '@ib-shared/services/countries-data.service';
import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
import { map, Observable, of, takeUntil } from 'rxjs';

import { SignUpFacadeService } from '../services/sign-up-facade.service';
import { SignUpFormHelperService } from '../services/sign-up-form-facade.service';
import { SignUpStateService } from '../services/sign-up-state.service';

@Component({
  selector: 'ib-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  providers: [SignUpStateService, SignUpFacadeService, SignUpFormHelperService],
})
export class SignUpComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public currStepConfig$ = this.facadeS
    .selectCurrStepConfig()
    .pipe(map(v => ({ v })));
  public isRegisterLoading$ = this.facadeS.selectIsRegisterLoading();
  public STEPS = INVESTOR_SIGN_UP_STEPS;

  @ViewChild('modalTmpl') modalTmpl: TemplateRef<unknown>;

  // TODO  - replace all related to unsaved changes to abstract class
  // @HostListener('window:beforeunload', ['$event'])
  // checkChanges(ev): void {
  //   if (
  //     !this.facadeS.isUserRegistered() &&
  //     !this.tsS.isTouchScreen &&
  //     this.facadeS.isUserFilledFirstStep()
  //   ) {
  //     ev.returnValue = 'Your data will be lost!';
  //   }
  // }

  // @HostListener('document:visibilitychange', ['$event'])
  // checkChangesMobile(ev): void {
  //   if (
  //     !this.facadeS.isUserRegistered() &&
  //     this.tsS.isTouchScreen &&
  //     this.facadeS.isUserFilledFirstStep()
  //   ) {
  //     ev.returnValue = 'Your data will be lost!';
  //   }
  // }

  constructor(
    public facadeS: SignUpFacadeService,
    private modalsS: ModalsService,
    public formS: SignUpFormHelperService,
    private countriesS: CountriesHttpService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.facadeS.initDefStepsData();
    this.countriesS
      .selectUserCountryByIp()
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
    this.formS.destroySubscriptions();
    this.facadeS.destroySubscriptions();
  }

  public checkIsUserFilledFirstStep(): Observable<boolean> {
    if (
      !this.facadeS.isUserRegistered() &&
      this.facadeS.isUserFilledFirstStep()
    ) {
      const modalRef = this.modalsS.openModal(this.modalTmpl, {
        width: '400px',
        maxWidth: '90vw',
        enterAnimationDuration: 0,
        exitAnimationDuration: 0,
      });
      return modalRef
        .afterClosed()
        .pipe(map(r => r || false)) as Observable<boolean>;
    } else {
      return of(true);
    }
  }
}
